<template>
  <div>
    <transition name="media-scale" v-if="isShowRedPacketDetail">
      <div class="media-scale pay-detail">
        <div class="pay-container">
          <div class="pay-header">
            <p>{{ $t("redpacket.detail") }}</p>
            <img :src="require('@/svg/redpacket_bg.svg')" />
          </div>
          <div class="pay-content" v-if="redPacketData">
            <div class="pay-content-top">
              <h4>
                <span class="textoverhide wid146" :title="redPacketData.userName">{{ redPacketData.userName }}</span
                >{{ $t("redpacket.sendPacket") }}
                <img
                  :src="require('@/svg/ping.svg')"
                  v-if="redPacketData.algorithm == 0"
                />
                <img :src="require('@/svg/dengfen.svg')" v-else />
              </h4>
              <h5 v-if="redPacketData.sendCount != drawList.length">
                {{ $t("redpacket.noReceiveTips") }}
              </h5>
            </div>
            <p
              class="pay-content-center"
              v-if="redPacketData.drawCount != redPacketData.sendCount"
            >
              {{ $t("redpacket.Receive") }}{{ drawList.length }}/{{
                redPacketData.sendCount
              }}{{ $t("redpacket.个") }}
            </p>
            <p class="pay-content-center" v-else>
              {{ redPacketData.sendCount }}{{ $t("redpacket.个")
              }}{{ $t("redpacket.redPacket") }}，{{
                (redPacketData.startToEndDuration / 60).toFixed() == 0
                  ? 1
                  : (redPacketData.startToEndDuration / 60).toFixed()
              }}{{ $t("redpacket.分钟被抢完")}}
            </p>
            <ul class="pay-content-bottom scrollbar">
              <li v-for="item in drawList" :key="item.openid">
                <img :src="item.headUrl" width="40" height="40" />
                <div class="pay-content-name">
                  <h4 class="textoverhide wid128" :title="item.nickname">{{ item.nickname }}</h4>
                  <p>{{ item.drawTime }}</p>
                </div>
                <span
                  >{{ (item.amount / 100).toFixed(2) }}{{ $t("redpacket.yuan")
                  }}<br /><span
                    class="pay-content-better"
                    v-show="
                      redPacketData.algorithm == 0 &&
                      redPacketData.drawCount == redPacketData.sendCount &&
                      item.amount == maxPrice
                    "
                    >{{ $t("redpacket.better") }}</span
                  ></span
                >
              </li>
              <li v-if="drawList.length == 0" class="no-receive-record">
                <img :src="require('@/svg/noreceiverecord.svg')" />
              </li>
            </ul>
          </div>
          <div @click="close" class="pay_close">
            <img :src="require('@/svg/redpacket_close.svg')" />
          </div>
        </div>

        <!-- <el-dialog
          v-bind="$attrs"
          v-on="$listeners"
          :key="'dialog'"
          :visible="isShowRedPacketDetail"
          :modal="false"
          :close-on-click-modal="false"
          :title="$t('redpacket.detail')"
          width="400px"
          class="dialog-dark dialog-center form-dark"
          @close="onClose"
        >
        </el-dialog> -->
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { drawRedpacket } from "@/api/redPacket";
export default {
  name: "redPacketForm",
  computed: {
    ...mapGetters(["isShowRedPacketDetail", "confId", "liveId", "userInfo"]),
    maxPrice() {
      let max = this.drawList[0].amount;
      for (let i = 1; i < this.drawList.length; i++) {
        max = max > this.drawList[i].amount ? max : this.drawList[i].amount;
      }
      return max;
    },
  },
  props: {
    idList: {
      type: String,
    },
  },
  data() {
    return {
      drawList: [],
      redPacketData: null,
    };
  },
  watch: {
    isShowRedPacketDetail: {
      handler(value) {
        if (value) {
          this.getDetail();
        }
      },
    },
  },
  methods: {
    async getDetail() {
      // const res1 = await getRedpacketDetail({
      //   cid: this.userInfo.cid,
      //   confId: this.confId,
      //   liveId: this.liveId,
      //   idList: this.idList,
      // });
      // if (res1.status == 0) {
      //   this.detailData = res1.data[0];
      // } else {
      //   this.$message.error(res1.message);
      //   return;
      // }
      const res2 = await drawRedpacket({
        cid: this.userInfo.cid,
        confId: this.confId,
        liveId: this.liveId,
        id: this.idList,
      });
      if (res2.status == 0) {
        this.drawList = res2.data.drawList;
        this.redPacketData = res2.data.redpacketInfo;
      } else {
        this.$message.error(res2.message);
      }
    },
    close() {
      this.$store.commit("SET_SHOW_RED_PACKEY_DETAIL", false);
    },
  },
};
</script>

<style scoped lang="scss">
.pay-detail {
  position: fixed;
  z-index: 111111;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  .pay-container {
    width: 336px;
    height: 556px;
    background: #ffffff;
    border-radius: 12px;
    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: absolute;
    .pay-header {
      width: 336px;
      height: 71px;
      line-height: 71px;
      font-size: 20px;
      color: #ffffff;
      border-radius: 12px;
      position: relative;
      img {
        position: absolute;
        left: 0;
        top: 0;
      }
      p {
        position: absolute;
        z-index: 1;
        left: 0;
        right: 0;
      }
    }
    .pay-content {
      margin: 27px 0px 20px 0px;
      .pay-content-top {
        h4 {
          font-size: 20px;
          font-weight: 400;
          color: #333333;
          line-height: 28px;
          margin-bottom: 7px;
        }
        h5 {
          font-size: 12px;
          font-weight: 400;
          color: #666666;
          line-height: 17px;
        }
        .wid146{
          max-width: 146px;
        }
      }
      .pay-content-center {
        color: #b3b3b3;
        line-height: 20px;
        font-size: 14px;
        text-align: left;
        border-bottom: 1px solid #e8e8e8;
        margin-left: 18px;
        padding: 10px 0px;
      }
      .pay-content-bottom {
        height: 360px;
        overflow-y: scroll;
        position: relative;
        li {
          display: flex;
          border-bottom: 1px solid #e8e8e8;
          margin: 0px 18px;
          height: 75px;
          align-items: center;
          img {
            border-radius: 50%;
          }
          .pay-content-name {
            width: calc(100% - 110px);
            text-align: left;
            padding-left: 14px;
            .wid128{
              max-width: 128px;
            }
            h4 {
              font-size: 18px;
              font-weight: 400;
              color: #333333;
              line-height: 25px;
              width: calc(100% - 10px);
              overflow: hidden;
              text-overflow: ellipsis;
            }
            p {
              font-size: 14px;
              font-weight: 400;
              color: #b3b3b3;
              line-height: 20px;
            }
          }
          .pay-content-better {
            font-size: 14px;
            color: #f49f48;
          }
        }
        .no-receive-record {
          border: none;
          height: auto;
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 0;
          margin: auto;
          width: 130px;
          img {
            border-radius: inherit;
          }
        }
      }
    }
  }
  .pay_close {
    position: absolute;
    // bottom: 100px;
    right: 0;
    left: 0;
    margin: auto;
    color: #ffff;
    cursor: pointer;
    bottom: -56px;
  }
  .textoverhide {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}
</style>